import { render, staticRenderFns } from "./StationV2Event.vue?vue&type=template&id=44c5f9b3&scoped=true&"
import script from "./StationV2Event.vue?vue&type=script&lang=js&"
export * from "./StationV2Event.vue?vue&type=script&lang=js&"
import style0 from "./StationV2Event.vue?vue&type=style&index=0&id=44c5f9b3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5f9b3",
  null
  
)

/* custom blocks */
import block0 from "./StationV2Event.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c5f9b3')) {
      api.createRecord('44c5f9b3', component.options)
    } else {
      api.reload('44c5f9b3', component.options)
    }
    module.hot.accept("./StationV2Event.vue?vue&type=template&id=44c5f9b3&scoped=true&", function () {
      api.rerender('44c5f9b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StationEvent/StationV2Event.vue"
export default component.exports